import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { InformationService } from "../api";

export const actionGetListProfile = createAsyncThunk(
  "info/getlistprofile",
  async (_, { rejectWithValue }) => {
    try {
      const res = await InformationService.doGetListProfile();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        // toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      // toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionUpdateProfile = createAsyncThunk(
  "info/updateProfile",
  async (data, { rejectWithValue }) => {
    try {
      const res = await InformationService.doEditProfile(data);
      if (!res.data.status) {
        toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetListCountry = createAsyncThunk(
  "info/listAddress-country",
  async (data, { rejectWithValue }) => {
    try {
      const res = await InformationService.doGetListCountry(data);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

export const actionGetListProvince = createAsyncThunk(
  "info/listAddress-province",
  async (parent, { rejectWithValue }) => {
    try {
      // console.log(parent, "123345678");

      const res = await InformationService.doGetListProvince(parent);
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

const informationSlice = createSlice({
  name: "info",
  initialState: {
    listProfile: {
      loading: false,
      data: null,
      error: "",
    },
    updateProfile: {
      loading: false,
      data: null,
      error: "",
    },
    listCountry: {
      loading: false,
      data: null,
      error: "",
    },
    listProvince: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // list profile
      .addCase(actionGetListProfile.pending, (state) => {
        state.listProfile.loading = true;
      })
      .addCase(actionGetListProfile.fulfilled, (state, action) => {
        state.listProfile.loading = false;
        state.listProfile.data = action.payload;
      })
      .addCase(actionGetListProfile.rejected, (state, action) => {
        state.listProfile.loading = false;
        state.listProfile.data = action.payload;
        state.listProfile.error =
          action.error.message || "Something went wrong";
      })
      // update profile
      .addCase(actionUpdateProfile.pending, (state) => {
        state.updateProfile.loading = true;
      })
      .addCase(actionUpdateProfile.fulfilled, (state, action) => {
        state.updateProfile.loading = false;
        state.updateProfile.data = action.payload;
      })
      .addCase(actionUpdateProfile.rejected, (state, action) => {
        state.updateProfile.loading = false;
        state.updateProfile.data = action.payload;
        state.updateProfile.error =
          action.error.message || "Something went wrong";
      })
      // list address Country
      .addCase(actionGetListCountry.pending, (state) => {
        state.listCountry.loading = true;
      })
      .addCase(actionGetListCountry.fulfilled, (state, action) => {
        state.listCountry.loading = false;
        state.listCountry.data = action.payload;
      })
      .addCase(actionGetListCountry.rejected, (state, action) => {
        state.listCountry.loading = false;
        state.listCountry.data = action.payload;
        state.listCountry.error =
          action.error.message || "Something went wrong";
      })
      // list address Province
      .addCase(actionGetListProvince.pending, (state) => {
        state.listProvince.loading = true;
      })
      .addCase(actionGetListProvince.fulfilled, (state, action) => {
        state.listProvince.loading = false;
        state.listProvince.data = action.payload;
      })
      .addCase(actionGetListProvince.rejected, (state, action) => {
        state.listProvince.loading = false;
        state.listProvince.data = action.payload;
        state.listProvince.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default informationSlice.reducer;
export const { actions, reducer } = informationSlice;
